import { fetchBegin } from '../actions/index';
import populateHeader from '../partials/resultado-geral';
import createMap from '../components/mapa/index';
import createScale from '../components/mapa/scale';
import './main.scss';

let listPreviusValue = {};
let loadingPreviusValue = null;

function loadingUpdate() {
  const loadingNode = document.querySelector('#loading');
  loadingNode.setAttribute('hidden', true);
}

function init(list) {
  populateHeader(list.NEWDATA);
  createScale(list);
  createMap(list);
}

function listenSubscribe(subscribe, getState) {
  subscribe(() => {
    const { initial } = getState();
    const { loading, list } = initial;

    if (loadingPreviusValue !== loading) {
      loadingUpdate(loading);
      loadingPreviusValue = loading;
    }

    if (!Object.is(listPreviusValue, list)) {
      listPreviusValue = list;
      init(list);
    }
  });
}

export default ({ dispatch, getState, subscribe }) => {
  const { loading } = getState();
  if (!loading) {
    dispatch(fetchBegin());
  }
  listenSubscribe(subscribe, getState);
};



// WEBPACK FOOTER //
// ./src/components/main.js